import Money from "js-money";
import currencies from "iso-currencies";
import pluralizer from "pluralize";
import humanizeString from "string-humanize";

const urlParser = document.createElement("a");

export function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

export function count(arr) {
  return arr.length;
}

export function pluralize(count, label) {
  return pluralizer(label, count);
}

export function money(amount, currencyCode) {
  let display = "";
  const money = Money.fromInteger(amount, currencyCode.toUpperCase());
  const currency = money.getCurrency();
  display += Money[currency].symbol;
  display += money.toString();
  return display;
}

export function currencySymbol(currencyCode) {
  let display = "";
  const currency = currencies.information(currencyCode.toUpperCase());
  if (currency && currency.symbol) {
    display = currency.symbol;
  }
  return display;
}

export function humanize(str) {
  let result = humanizeString(str);

  // handle some special cases
  if (str === "bluePad5000") {
    result = "BluePad 5000";
  } else if (str === "bluePad50") {
    result = "BluePad 50";
  } else if (str === "bluePad55") {
    result = "BluePad 55";
  }

  return result;
}
